<template>
    <body class="">
        <!-- header -->
        <header id="header">
            <div class="container">
                <div class="nav">
                    <button class="btn btn-nav" @click="fn_gnbShow()">
                        <span class="blind">메뉴</span>
                    </button>
                    <button class="btn btn-back" @click="backbtn()">
                        <span class="blind">뒤로가기</span>
                    </button>
                </div>
                <div class="title">
                    <!-- <a ><img src="../assets/images/common/img_logo.png" alt=""></a> -->
                    <span>Face Mapping List</span>
                </div>
            </div>
        </header>
        <!-- // header -->

        <!-- gnb -->
        <gnb :gnb-on="gnbShow" @getChildGnbShow="getChildGnbShow" />
        <div class="gnb-dimmed" :class="gnbShow" @click="getChildGnbShow()" />
        <!-- // gnb -->

        <div id="content-wrap">
            <div id="contents">
                <!-- step info -->
                <div class="list-info-wrapper">
                    <div class="container">
                        <ul>
                            <li class="on" @click="movePage('List')">
                                <span>페이스맵핑목록</span>
                            </li>
                            <li @click="movePage('SlideNATM')">
                                <span>NATM슬라이드</span>
                            </li>
                            <li @click="movePage('SlideTBM')">
                                <span>TBM슬라이드</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- // step info -->

                <div class="list-wrapper">
                    <div class="container">
                        <div class="list-search-box">
                            <div class="search-item">
                                <div class="select-box">
                                    <select v-model="param.tunnelConstructionMethod" @change="search">
                                        <option value="">
                                            터널공법
                                        </option>
                                        <option
                                            v-for="(item, index) in tunnelConstructionMethodList"
                                            :key="index"
                                            :value="item.code"
                                        >
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>

                                <!-- <input v-model="param.investigationDay" type="date" class="txt date" require /> -->
                                <div class="select-box" style="width:178px">
                                    <select v-model="param.approveState" @change="search()">
                                        <option value="">
                                            결재상태
                                        </option>
                                        <option value="request">
                                            작성중
                                        </option>
                                        <option value="waiting">
                                            결재중
                                        </option>
                                        <option value="approve">
                                            결재완료
                                        </option>
                                        <option value="approve">
                                            반려결재
                                        </option>
                                    </select>
                                </div>
                                <input
                                    v-model="param.geologist"
                                    type="text"
                                    class="txt"
                                    placeholder="관찰자명"
                                    style="width: 130px;"
                                />
                                <button type="button" class="btn btn-search" @click="search">
                                    <span>검색</span>
                                </button>
                                <label>
                                    <input
                                        v-model="param.isMyApproval"
                                        type="checkbox"
                                        class="chk"
                                        value="Y"
                                        @change="search"
                                    />
                                    <span>내 결재대기</span>
                                </label>
                            </div>
                            <div v-if="isEditing()" class="reg-box">
                                <button type="button" class="btn btn-reg" @click="write">
                                    <span>신규등록</span>
                                </button>
                            </div>
                        </div>

                        <!-- fms-list-wrapper -->
                        <div v-if="isList" class="fms-list-wrapper">
                            <!-- fms-list-box -->
                            <div v-for="(data, index) in datas" :key="index" class="fms-list-box">
                                <div
                                    class="fms-list-top"
                                    @click="detail(data.tunnelConstructionMethod, data.constructionCode, data.id)"
                                >
                                    <div
                                        v-if="data.tunnelConstructionMethod == tunnelConstructionTBM"
                                        class="image-box"
                                    >
                                        <div class="image image-2">
                                            <img
                                                :src="fileUrl + data.tbmLeftImageUrl"
                                                :alt="fileUrl + data.tbmLeftImageUrl"
                                                @error="imgError"
                                            />
                                        </div>
                                        <div class="image image-2">
                                            <img
                                                :src="fileUrl + data.tbmRightImageUrl"
                                                :alt="fileUrl + data.tbmRightImageUrl"
                                                @error="imgError"
                                            />
                                        </div>
                                    </div>

                                    <div v-else class="image-box">
                                        <div class="image image-1">
                                            <img
                                                v-if="data.threeDimensionalImageUrl"
                                                :src="fileUrl + data.threeDimensionalImageUrl"
                                                :alt="fileUrl + data.threeDimensionalImageUrl"
                                                @error="imgError"
                                            />
                                            <img
                                                v-else
                                                :src="fileUrl + data.frontImageUrl"
                                                :alt="fileUrl + data.frontImageUrl"
                                                @error="imgError"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="data.judgementYn === 'Y'" class="non-face-box">
                                        <dl>
                                            <dt>회의시간</dt>
                                            <dd>{{ data.judgementDay }} {{ data.judgementTime }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>비대면여부</dt>
                                            <dd>{{ data.nonFaceYn }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>메세지</dt>
                                            <dd>{{ data.judgementMessage }}</dd>
                                        </dl>
                                    </div>
                                    <div class="summary-box">
                                        <dl>
                                            <dt>STA</dt>
                                            <dd>{{ data.station }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>RMR</dt>
                                            <dd>{{ data.rmr }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>Observer</dt>
                                            <dd>{{ data.geologist }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>Date</dt>
                                            <dd>{{ data.investigationDay }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>터널공법</dt>
                                            <dd>{{ data.tunnelConstructionMethodName }}</dd>
                                        </dl>
                                        <dl>
                                            <dt>결재 대기</dt>
                                            <dd v-if="memberId === data.approvalMemberId">
                                                <span style="color: green;font-weight: bold;">{{
                                                    data.approvalMemberName
                                                }}</span>
                                            </dd>
                                            <dd v-else>
                                                {{ data.approvalMemberName }}
                                            </dd>
                                        </dl>
                                    </div>
                                </div>
                                <div class="fms-list-bottom">
                                    <div class="btn-inbox">
                                        <button
                                            v-if="isEditing()"
                                            type="button"
                                            class="btn btn-list-del"
                                            @click="remove(data.id)"
                                        >
                                            <span>삭제</span>
                                        </button>
                                    </div>
                                    <div class="btn-inbox">
                                        <button
                                            v-if="isEditing()"
                                            type="button"
                                            class="btn btn-list-copy"
                                            @click="copy(data.id, data.station)"
                                        >
                                            <span>내용복사</span>
                                        </button>
                                        <button
                                            v-if="data.approveState === 'request'"
                                            type="button"
                                            class="btn btn-list-modify"
                                            @click="modify(data)"
                                        >
                                            <span>내용수정</span>
                                        </button>
                                    </div>
                                    <div
                                        v-if="data.tunnelConstructionMethod == tunnelConstructionNATM"
                                        class="status-inbox"
                                    >
                                        <div class="status-change">
                                            <button
                                                v-if="data.judgementYn === 'Y'"
                                                type="button"
                                                class="btn btn-list-del"
                                                @click="sendSms(data.id)"
                                            >
                                                <span>전송하기</span>
                                            </button>
                                            <span v-if="data.judgementYn === 'Y'" style="padding-right: 10px;" />
                                            <div class="title">
                                                상태변경
                                            </div>
                                            <div class="select-box">
                                                <select
                                                    v-model="data.approveState"
                                                    class="approveState"
                                                    :class="getStatus(data.approveState)"
                                                    :disabled="isEditing"
                                                    @change="approve(data.approveState, data.id)"
                                                >
                                                    <option value="request" class="request">
                                                        작성중
                                                    </option>
                                                    <option value="waiting" class="waiting">
                                                        결재요청(대기)
                                                    </option>
                                                    <option value="approve" class="approve">
                                                        결재완료
                                                    </option>
                                                    <option value="approve" class="reject">
                                                        반려결재
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <pagination :page-param="pageParam" @pageCallback="pageCallback" />
                            <confirm :param="confirmParam" @confirmCallback="confirmCallback" />
                        </div>
                        <div v-else class="fms-list-wrapper empty-list">
                            목록이 없습니다.
                        </div>
                        <!-- // fms-list-wrapper -->
                    </div>
                </div>
            </div>
        </div>
    </body>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CodeApi from '../api/CodeApi';
import FacemappingApi from '../api/FacemappingApi';
import { COMM_CODE, FILE_URL, MEMBER_ID, NO_IMG, PAGINATION, PARAM_OBJECT, TUNNEL_CONSTRUCTION, TYPE } from '../const';
import confirm from './common/Confirm.vue';
import pagination from './common/pagination.vue';
import gnb from './layout/gnb.vue';

export default {
    name: 'List',
    components: {
        gnb,
        pagination,
        confirm
    },
    data: () => {
        return {
            datas: {},
            param: {
                page: PAGINATION.number,
                rows: PAGINATION.numberOfElements,
                sort: 'investigationDay desc,reg_dt',
                direction: 'desc',
                geologist: '',
                investigationDay: '',
                tunnelConstructionMethod: '',
                approveState: '',
                isMyApproval: false
            },
            tunnelConstructionMethodList: [],
            type: [],
            gnbShow: '',
            fileUrl: FILE_URL,
            pageParam: {
                curPage: PAGINATION.number,
                totalCnt: PAGINATION.totalPages,
                lstCnt: PAGINATION.numberOfElements,
                pageCnt: PAGINATION.size
            },
            tunnelConstructionNATM: TUNNEL_CONSTRUCTION.NATM,
            tunnelConstructionTBM: TUNNEL_CONSTRUCTION.TBM,
            confirmParam: {
                msg: '',
                isShow: false,
                callbackParam: {}
            },
            isList: true,
            authType: 'observer',
            memberId: ''
        };
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {
        if (this.$route.params.target !== null) {
            this.param.approveState = this.$route.params.target;
        } else {
            if (localStorage.getItem(PARAM_OBJECT) !== null) {
                this.param = JSON.parse(localStorage.getItem(PARAM_OBJECT));
            }
        }
    },
    mounted() {
        this.authType = localStorage.getItem(TYPE);
        this.memberId = localStorage.getItem(MEMBER_ID);
        //ScreenHelper.setPortrait();
        this.codeSettign(COMM_CODE.tunnelConstruction);
        this.list();
        if (this.param.approveState === 'myApproval') {
            this.param.approveState = 'waiting';
            this.param.isMyApproval = true;
        } else if (!this.param.approveState) this.param.approveState = '';
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading', 'alert']),
        backbtn() {
            this.$router.go(-1);
        },
        imgError(e) {
            e.target.src = NO_IMG;
        },
        fn_gnbShow() {
            this.gnbShow = 'on';
            $('html').addClass('off');
        },
        getChildGnbShow() {
            this.gnbShow = '';
            $('html').removeClass('off');
        },
        write() {
            this.$router.push({
                name: 'Step1'
            });
        },
        search() {
            this.param.page = 1;
            this.list();
        },
        list() {
            this.showLoading();
            var that = this;
            FacemappingApi.list(this.param).then(res => {
                this.datas = res.content;
                this.isList = res.content.length > 0 ? true : false;
                this.pageParam.totalCnt = res.pageable.total;
                this.pageParam.curPage = res.pageable.page + 1;

                localStorage.setItem(PARAM_OBJECT, JSON.stringify(that.param));
                this.hideLoading();
            });
        },
        modify(item) {
            var param = {};
            param.isShow = true;
            if (item.approveState === 'approve' || item.approveState === 'reject') {
                param.msg = '결재완료는 수정할 수 없습니다.';
                this.alert(param);
                return;
            }
            this.$router.push({ path: `/step1/${item.id}` });
        },
        approve(approveState, id) {
            var callbackParam = {};
            callbackParam.approveState = approveState;
            callbackParam.id = id;
            callbackParam.type = 'approve';

            //var param = {};
            this.confirmParam.msg = '상태를 변경 하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },

        confirmCallback(callbackParam) {
            var param = {};
            param.isShow = true;

            if (callbackParam.type === 'remove') {
                FacemappingApi.deleteData(callbackParam.id).then(() => {
                    param.msg = '삭제 되었습니다.';
                    this.alert(param);
                    this.list();
                });
            }
            if (callbackParam.type === 'approve') {
                FacemappingApi.approve(callbackParam.id, callbackParam.approveState).then(() => {
                    param.msg = '변경 되었습니다.';
                    this.alert(param);
                    this.list();
                });
            }
            if (callbackParam.type === 'copy') {
                FacemappingApi.copy(callbackParam.id).then(() => {
                    param.msg = '복사 되었습니다.';
                    this.alert(param);
                    this.list();
                });
            }
            if (callbackParam.type === 'send') {
                FacemappingApi.sendSms(callbackParam.id).then(() => {
                    param.msg = '전송 되었습니다.';
                    this.alert(param);
                    this.list();
                });
            }
        },

        detail(tunnelConstructionMethod, constructionCode, id) {
            if (tunnelConstructionMethod === TUNNEL_CONSTRUCTION.NATM)
                this.$router.push({ path: `/detail/${constructionCode}/${id}` });
            else this.$router.push({ path: `/detailTBM/${constructionCode}/${id}` });
        },
        copy(id, station) {
            var callbackParam = {};
            callbackParam.id = id;
            callbackParam.type = 'copy';
            this.confirmParam.msg = ' [ ' + station + ' ] 복사하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        remove(id) {
            var callbackParam = {};
            callbackParam.id = id;
            callbackParam.type = 'remove';
            this.confirmParam.msg = '삭제하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        approveState(approveState) {
            return approveState === 'request' ? 'type-1' : approveState === 'waiting' ? 'type-2' : 'type-3';
        },
        approveStateText(approveState) {
            return approveState === 'request'
                ? '작성중'
                : approveState === 'waiting'
                ? '페이스맵핑 작업요청'
                : '페이스매핑 작업완료';
        },
        codeSettign(code) {
            CodeApi.subCodeList(code, 2).then(res => {
                this.tunnelConstructionMethodList = res.content;
            });
        },
        movePage(target) {
            this.$router.push({
                name: target
            });
        },
        pageCallback(page) {
            this.param.page = page;
            this.list();
        },
        isEditing() {
            if (this.authType === 'admin' || this.authType === 'observer') return true;
            else return false;
        },
        sendSms(id) {
            var callbackParam = {};
            callbackParam.id = id;
            callbackParam.type = 'send';
            this.confirmParam.msg = '문자/메일로 회의 일정을 공유하시겠습니까?';
            this.confirmParam.isShow = true;
            this.confirmParam.callbackParam = callbackParam;
        },
        getStatus(approveState) {
            return approveState === 'request' ? 'request' : approveState === 'waiting' ? 'waiting' : 'approve';
        }
    }
};
/*
#wrap > div {
    height: inherit;
}
*/
</script>
